export interface Organization {
  id: string
  name: string
  pending: boolean
  organizationType?: OrganizationType
  onboardingCompleted?: boolean
  modules: ReadonlyArray<ApplicationModule>
}

export enum OrganizationType {
  BUSINESS = 'business',
  EDU_LP = 'edu_lp',
  EDU_SUS = 'edu_sus',
}

export enum ApplicationModule {
  CORE = 'core',
  EDUCATION = 'education',
  DIALOG = 'dialog',
  COACHING = 'coaching',
  SUPERVISED_COACHING = 'supervised_coaching',
  ASSESSMENT = 'assessment',
  LUMIA = 'lumia',
}
